import {
  Box,
  Flex,
  Stack,
  Button,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { FaAndroid } from 'react-icons/fa';

import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import { useDownloadApp } from './hooks/useDownloadApp';

function SidebarContent({ routes, collapse }) {
  const bg = useColorModeValue(
    'white', // Clean white background for modern look
    'navy.800',
  );

  const borderClr = useColorModeValue('gray.200', 'whiteAlpha.100');

  // ✅ HOOK GOES HERE
  const { mutate: downloadApkFile, isLoading, progress } = useDownloadApp();

  return (
    <Flex
      direction="column"
      h="100vh"
      px={collapse ? '10px' : '5px'}
      py="20px"
      bg={bg}
      borderRadius={collapse ? '16px' : '30px'}
      borderRight="1px solid"
      borderColor={borderClr}
      transition="all 0.3s"
      alignItems={collapse ? 'center' : 'stretch'}
    >
      {/* ===== BRAND ===== */}
      <Box mt="10px" display="flex" justifyContent="center">
        <Brand collapse={collapse} />
      </Box>

      {/* ===== LINKS ===== */}
      <Stack
        flex="1"
        spacing="6px"
        overflowY="auto"
        alignItems={collapse ? 'center' : 'stretch'}
        w="100%"
      >
        <Links routes={routes} collapse={collapse} />
      </Stack>

      {!collapse && (
        <Button
          w="95%"
          h="35px"
          colorScheme="green"
          borderRadius="xl"
          isDisabled={isLoading}
          onClick={downloadApkFile}
          position="relative"
          overflow="hidden"
        >
          {isLoading && (
            <Box
              position="absolute"
              left="0"
              top="0"
              h="100%"
              w={`${progress}%`}
              bg="green.400"
              opacity={0.35}
              transition="width 0.2s ease"
            />
          )}

          <Box position="relative" zIndex={1}>
            {isLoading ? `Downloading… ${progress}%` : 'Download Android App'}
          </Box>
        </Button>
      )}
    </Flex>
  );
}

export default SidebarContent;
